import type { SVGProps } from "react";
import * as React from "react";

const SvgAlignCenter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18 11a1 1 0 1 0 0-2zM6 9a1 1 0 0 0 0 2zm15-2a1 1 0 1 0 0-2zM3 5a1 1 0 0 0 0 2zm18 10a1 1 0 1 0 0-2zM3 13a1 1 0 1 0 0 2zm15 6a1 1 0 1 0 0-2zM6 17a1 1 0 1 0 0 2zm12-8H6v2h12zm3-4H3v2h18zm0 8H3v2h18zm-3 4H6v2h12z"
    />
  </svg>
);
export default SvgAlignCenter;
